import { render } from "./default.vue?vue&type=template&id=9c447d0a&scoped=true"
import script from "./default.vue?vue&type=script&lang=ts"
export * from "./default.vue?vue&type=script&lang=ts"

import "./default.vue?vue&type=style&index=0&id=9c447d0a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9c447d0a"

export default script

/* vue-cli-plugin-import-components */
import DefaultHeader from "@/components/layouts/default/DefaultHeader.vue";
script.components = Object.assign({}, { DefaultHeader }, script.components);if (script.options) { script.options.components = Object.assign({}, { DefaultHeader }, script.options.components);}